import { render, staticRenderFns } from "./AddEditCompany.vue?vue&type=template&id=77cecdbc&"
import script from "./AddEditCompany.vue?vue&type=script&lang=ts&"
export * from "./AddEditCompany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports